// extracted by mini-css-extract-plugin
export default {"sumCard":"sumCard_sumCard__wSBL6","sumCard__item":"sumCard_sumCard__item__snwS5"};